<app-service-detail>
    <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
    </app-variables-tabs>
    <section class="layer col-md-12 ml-auto p-0" style="background: white;">

        <table *ngIf="!hideList"
               class="table table-bordered table-striped"
               style="table-layout: fixed;">
            <thead>
                <tr>
                    <th style="width:50%; text-align:left">
                        {{ 'annexes.docs.name' | translate }}
                        <input [(ngModel)]="searchValue"
                               (input)="searchTextChanged($event.target.value)"
                               class="form-control form-control-sm"
                               placeholder="{{ 'general.search' | translate }}"
                               type="text" />
                    </th>
                    <th>{{ 'annexes.short_name' | translate }}</th>
                    <th>{{ 'annexes.file' | translate }}</th>
                    <th style="width:100px">
                        <a class="editBtn btn-dark text-nowrap" (click)="loadLaw(null)">
                            {{ 'Add' | translate }}
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let law of laws | filterBy: searchTextFilterObject">
                    <td>
                        <primary-text-button [noLeftPadding]="true" (click)="loadLaw(law)">
                            {{ law.name }}
                        </primary-text-button>
                    </td>
                    <td>{{ law.shortName }}</td>
                    <td>
                        <div>
                            <i *ngIf="law.fileId"
                               (click)="download(law)"
                               tooltip="{{ 'annexes.download_file' | translate }}"
                               download
                               class="fa fa-file list-group-item-v2__edit"></i>

                            <label *ngIf="isActive"
                                   class="fa fa-paperclip list-group-item-v2__edit"
                                   tooltip="{{ 'annexes.upload_file' | translate }}"
                                   style="margin-bottom: 0;color:#f78b95;cursor:pointer">
                                <file-uploader [item]="law"
                                               (fileIdChanged)="handleUpload($event, law)"></file-uploader>
                            </label>
                            <i *ngIf="isActive && law.fileId"
                               tooltip="{{ 'annexes.erase_file' | translate }}"
                               class="fa fa-eraser list-group-item-v2__edit services-icon--dangerous"
                               [ngClass]="{ active: isActive }"
                               (click)="deleteFile(law)"></i>
                        </div>
                    </td>
                    <td class="w-auto text-center">
                        <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon"
                           (click)="delete(law)"></i>
                    </td>
                </tr>
                <tr>
                    <td colspan="3" class="text-center">
                        {{ 'annexes.add_file' | translate }}
                    </td>
                    <td style="text-align:center;">
                        <a class="editBtn btn-dark text-nowrap" (click)="loadLaw(null)">
                            {{ 'Add' | translate }}
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>

        <div *ngIf="showEdit || showAdd"
             class="layer half-layer col px-3"
             [ngStyle]="style"
             mwlResizable
             [enableGhostResize]="true"
             [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
             (resizeEnd)="onResizeEnd($event)"
             style="min-height:calc(100vh - 9.1rem);">
            <div class="moving px-3">
                <law-new [serviceId]="serviceId"
                         [law]="law"
                         (editCancel)="closeLayers()"
                         (formSubmit)="closeSlider()"></law-new>
            </div>
        </div>
        <div class="shadow"></div>
    </section>
</app-service-detail>
